__turbopack_context__.v({
  "dropdown": "_48sLCq_dropdown",
  "option": "_48sLCq_option",
  "options": "_48sLCq_options",
});
